import httpRequest from '@/server/http-api'


const getSystemType = function() {
  var systemType = '';

  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
    systemType = 'ios';
  } else { //判断Android 和 pc
    systemType = 'android';
  }

  return systemType;
}
const configShareWX = function(callback) { 
  var href = window.location.href.split("#")[0];
  // const systemType = getSystemType(); 
  var params = {
    url: href,
    // url: systemType == 'ios' ? encodeURIComponent(href) : href,
  };

  httpRequest.getShareWXSDK(params)
    .then(res => {
      callback && callback(res);
    })
    .catch(err => {
      callback && callback(err);
    });
};

const configSDK = function(SDKParams,shareDetail) {
  console.log('----------配置参数-------');
  (SDKParams);

  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: SDKParams.appid, // 必填，公众号的唯一标识
    timestamp: SDKParams.timestamp, // 必填，生成签名的时间戳
    nonceStr: SDKParams.noncestr, // 必填，生成签名的随机串
    signature: SDKParams.signature, // 必填，签名
    jsApiList: [
      "checkJsApi",
      'updateTimelineShareData',
      'updateAppMessageShareData',
      'onMenuShareTimeline',
      'onMenuShareAppMessage'
    ], // 必填，需要使用的JS接口列表
    openTagList: ['wx-open-launch-app']
  });

  wx.ready(function() {
    wx.checkJsApi({
      jsApiList: ['wx-open-launch-app'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
      success: function (res) {
        console.log('checkJsApi可用')
      },
      fail: (err) => {
        console.log('checkJsApi--' + JSON.stringify(err));
      }
    })

    //需在用户可能点击分享按钮前就先调用
    // var href = window.location.href.split("#")[0];

    // wx.updateTimelineShareData({
    //   title: shareDetail.name, // 分享标题
    //   link: href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //   imgUrl: shareDetail.logo, // 分享图标
    //   success: function() {
    //     // 设置成功
        
    //   }
    // });

    // wx.onMenuShareTimeline({
    //   title: shareDetail.name, // 分享标题
    //   link: href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //   imgUrl: shareDetail.logo, // 分享图标
    //   success: function() {
    //     // 设置成功
    //   }
    // });

    // wx.updateAppMessageShareData({
    //   title: shareDetail.name, // 分享标题
    //   desc: shareDetail.summary, // 分享描述
    //   link: href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //   imgUrl: shareDetail.logo, // 分享图标
    //   type: "link", // 分享类型,music、video或link，不填默认为link
    //   dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
    //   success: function() {
    //     // 设置成功
    //   }
    // }); 

    // wx.onMenuShareAppMessage({
    //   title:  shareDetail.name, // 分享标题
    //   desc: shareDetail.summary, // 分享描述
    //   link: href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //   imgUrl: shareDetail.logo, // 分享图标
    //   type: "link", // 分享类型,music、video或link，不填默认为link
    //   dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
    //   success: function() {
    //     // 设置成功
    //   }
    // });

    wx.error(function(res) {
      alert('error---' + JSON.stringify(res));
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    });

  });
}

const configWxShareByServe = function(shareDetail) {
  configShareWX(function(ret) {
    if (!ret) return;
    if (ret.code == 200) {
      configSDK(ret.data,shareDetail);
    }
  })
};



export {
  configWxShareByServe
}



// WEBPACK FOOTER //
// ./src/utils/configWX.js